@if (text) {
    <a [routerLink]="link" class="text-primary-800">
        {{ text }}
    </a>
}
